import { defineComponent as $, getCurrentInstance as O, computed as s, ref as T, watch as N, provide as R, h as g } from "vue";
import { ArrowRight as G, ArrowLeft as V } from "./index537.js";
import { elPaginationKey as D } from "./index657.js";
import H from "./index658.js";
import K from "./index659.js";
import q from "./index660.js";
import F from "./index661.js";
import J from "./index662.js";
import Q from "./index663.js";
import { useSizeProp as X, useGlobalSize as Y } from "./index607.js";
import { buildProps as Z, definePropType as k } from "./index601.js";
import { iconPropType as E } from "./index606.js";
import { mutable as ee } from "./index612.js";
import { isNumber as l } from "./index565.js";
import { useLocale as te } from "./index597.js";
import { useNamespace as ae } from "./index559.js";
import { useDeprecated as ne } from "./index664.js";
import { CHANGE_EVENT as re } from "./index584.js";
import { debugWarn as ie } from "./index588.js";
const a = (e) => typeof e != "number", le = Z({
  /**
   * @description options of item count per page
   */
  pageSize: Number,
  /**
   * @description default initial value of page size, not setting is the same as setting 10
   */
  defaultPageSize: Number,
  /**
   * @description total item count
   */
  total: Number,
  /**
   * @description total page count. Set either `total` or `page-count` and pages will be displayed; if you need `page-sizes`, `total` is required
   */
  pageCount: Number,
  /**
   * @description number of pagers. Pagination collapses when the total page count exceeds this value
   */
  pagerCount: {
    type: Number,
    validator: (e) => l(e) && Math.trunc(e) === e && e > 4 && e < 22 && e % 2 === 1,
    default: 7
  },
  /**
   * @description current page number
   */
  currentPage: Number,
  /**
   * @description default initial value of current-page, not setting is the same as setting 1
   */
  defaultCurrentPage: Number,
  /**
   * @description layout of Pagination, elements separated with a comma
   */
  layout: {
    type: String,
    default: ["prev", "pager", "next", "jumper", "->", "total"].join(", ")
  },
  /**
   * @description item count of each page
   */
  pageSizes: {
    type: k(Array),
    default: () => ee([10, 20, 30, 40, 50, 100])
  },
  /**
   * @description custom class name for the page size Select's dropdown
   */
  popperClass: {
    type: String,
    default: ""
  },
  /**
   * @description custom style for the page size Select's dropdown
   */
  popperStyle: {
    type: k([String, Object])
  },
  /**
   * @description text for the prev button
   */
  prevText: {
    type: String,
    default: ""
  },
  /**
   * @description icon for the prev button, higher priority of `prev-text`
   */
  prevIcon: {
    type: E,
    default: () => V
  },
  /**
   * @description text for the next button
   */
  nextText: {
    type: String,
    default: ""
  },
  /**
   * @description icon for the next button, higher priority of `next-text`
   */
  nextIcon: {
    type: E,
    default: () => G
  },
  /**
   * @description whether Pagination size is teleported to body
   */
  teleported: {
    type: Boolean,
    default: !0
  },
  /**
   * @description whether to use small pagination
   */
  small: Boolean,
  /**
   * @description set page size
   */
  size: X,
  /**
   * @description whether the buttons have a background color
   */
  background: Boolean,
  /**
   * @description whether Pagination is disabled
   */
  disabled: Boolean,
  /**
   * @description whether to hide when there's only one page
   */
  hideOnSinglePage: Boolean,
  /**
   * @description which element the size dropdown appends to.
   */
  appendSizeTo: String
}), ue = {
  "update:current-page": (e) => l(e),
  "update:page-size": (e) => l(e),
  "size-change": (e) => l(e),
  change: (e, i) => l(e) && l(i),
  "current-change": (e) => l(e),
  "prev-click": (e) => l(e),
  "next-click": (e) => l(e)
}, w = "ElPagination";
var Ne = $({
  name: w,
  props: le,
  emits: ue,
  setup(e, { emit: i, slots: h }) {
    const { t: B } = te(), u = ae("pagination"), c = O().vnode.props || {}, A = Y(), C = s(
      () => {
        var t;
        return e.small ? "small" : (t = e.size) != null ? t : A.value;
      }
    );
    ne(
      {
        from: "small",
        replacement: "size",
        version: "3.0.0",
        scope: "el-pagination",
        ref: "https://element-plus.org/zh-CN/component/pagination.html"
      },
      s(() => !!e.small)
    );
    const S = "onUpdate:currentPage" in c || "onUpdate:current-page" in c || "onCurrentChange" in c, z = "onUpdate:pageSize" in c || "onUpdate:page-size" in c || "onSizeChange" in c, I = s(() => {
      if (a(e.total) && a(e.pageCount) || !a(e.currentPage) && !S) return !1;
      if (e.layout.includes("sizes")) {
        if (a(e.pageCount)) {
          if (!a(e.total) && !a(e.pageSize) && !z)
            return !1;
        } else if (!z) return !1;
      }
      return !0;
    }), b = T(
      a(e.defaultPageSize) ? 10 : e.defaultPageSize
    ), _ = T(
      a(e.defaultCurrentPage) ? 1 : e.defaultCurrentPage
    ), m = s({
      get() {
        return a(e.pageSize) ? b.value : e.pageSize;
      },
      set(t) {
        a(e.pageSize) && (b.value = t), z && (i("update:page-size", t), i("size-change", t));
      }
    }), o = s(() => {
      let t = 0;
      return a(e.pageCount) ? a(e.total) || (t = Math.max(1, Math.ceil(e.total / m.value))) : t = e.pageCount, t;
    }), n = s({
      get() {
        return a(e.currentPage) ? _.value : e.currentPage;
      },
      set(t) {
        let r = t;
        t < 1 ? r = 1 : t > o.value && (r = o.value), a(e.currentPage) && (_.value = r), S && (i("update:current-page", r), i("current-change", r));
      }
    });
    N(o, (t) => {
      n.value > t && (n.value = t);
    }), N(
      [n, m],
      (t) => {
        i(re, ...t);
      },
      { flush: "post" }
    );
    function y(t) {
      n.value = t;
    }
    function j(t) {
      m.value = t;
      const r = o.value;
      n.value > r && (n.value = r);
    }
    function L() {
      e.disabled || (n.value -= 1, i("prev-click", n.value));
    }
    function M() {
      e.disabled || (n.value += 1, i("next-click", n.value));
    }
    function v(t, r) {
      t && (t.props || (t.props = {}), t.props.class = [t.props.class, r].join(" "));
    }
    return R(D, {
      pageCount: o,
      disabled: s(() => e.disabled),
      currentPage: n,
      changeEvent: y,
      handleSizeChange: j
    }), () => {
      var t, r;
      if (!I.value)
        return ie(w, B("el.pagination.deprecationWarning")), null;
      if (!e.layout || e.hideOnSinglePage && o.value <= 1) return null;
      const f = [], d = [], U = g(
        "div",
        { class: u.e("rightwrapper") },
        d
      ), x = {
        prev: g(H, {
          disabled: e.disabled,
          currentPage: n.value,
          prevText: e.prevText,
          prevIcon: e.prevIcon,
          onClick: L
        }),
        jumper: g(F, {
          size: C.value
        }),
        pager: g(Q, {
          currentPage: n.value,
          pageCount: o.value,
          pagerCount: e.pagerCount,
          onChange: y,
          disabled: e.disabled
        }),
        next: g(K, {
          disabled: e.disabled,
          currentPage: n.value,
          pageCount: o.value,
          nextText: e.nextText,
          nextIcon: e.nextIcon,
          onClick: M
        }),
        sizes: g(q, {
          pageSize: m.value,
          pageSizes: e.pageSizes,
          popperClass: e.popperClass,
          popperStyle: e.popperStyle,
          disabled: e.disabled,
          teleported: e.teleported,
          size: C.value,
          appendSizeTo: e.appendSizeTo
        }),
        slot: (r = (t = h?.default) == null ? void 0 : t.call(h)) != null ? r : null,
        total: g(J, { total: a(e.total) ? 0 : e.total })
      }, W = e.layout.split(",").map((p) => p.trim());
      let P = !1;
      return W.forEach((p) => {
        if (p === "->") {
          P = !0;
          return;
        }
        P ? d.push(x[p]) : f.push(x[p]);
      }), v(f[0], u.is("first")), v(f[f.length - 1], u.is("last")), P && d.length > 0 && (v(d[0], u.is("first")), v(
        d[d.length - 1],
        u.is("last")
      ), f.push(U)), g(
        "div",
        {
          class: [
            u.b(),
            u.is("background", e.background),
            u.m(C.value)
          ]
        },
        f
      );
    };
  }
});
export {
  Ne as default,
  ue as paginationEmits,
  le as paginationProps
};
